export default __webpack_public_path__ + "static/media/marguerita.29d3b8d6.jpg";